// @core/api/endpoints/task/get_template.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TaskTemplateResponse,
} from '../../../types/task';

const BASE_PATH = '/task';

/**
 * Get template
 * Returns a task template by ID.
 */
export async function GetTemplate(
  template_id: string,
  options?: RequestOptions
): Promise<TaskTemplateResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/task-templates/:template_id`;
  requestPath = requestPath.replace(':template_id', encodeURIComponent(template_id));
  const requestOptions = options;
  return client.get<TaskTemplateResponse>(requestPath, { ...requestOptions });
}
